import { render, staticRenderFns } from "./PdaMenu.vue?vue&type=template&id=48f69751&scoped=true"
import script from "./PdaMenu.vue?vue&type=script&lang=js"
export * from "./PdaMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f69751",
  null
  
)

export default component.exports